import React from 'react';
import Modal from 'shared/components/Modal';
import { connect } from 'react-redux';
import { hideModal } from 'shared/actions/UnboundModalActions';

const ModalRouter = ({ activeModal, modals, dispatch, ...rest }) => {
  if (activeModal) {
    const { name, visible, ...modalComponentProps } = activeModal;
    const route = modals.find(modal => modal.name === name);
    if (route) {
      return (
        <Modal show={visible} {...route.modalOptions} onHide={() => dispatch(hideModal())}>
          {React.createElement(route.component, { ...rest, ...modalComponentProps })}
        </Modal>
      );
    }
    return null;
  } else {
    return null;
  }
};

const mapStateToProps = state => {
  return {
    activeModal: state.activeModal,
  };
};

export default connect(mapStateToProps)(ModalRouter);
